import React from "react";

import { css, menu } from "../stitches.config";
import SlMenu from "@shoelace-style/react/dist/menu";
import SlMenuItem from "@shoelace-style/react/dist/menu-item";
import SlDivider from "@shoelace-style/react/dist/divider";
import { useActions, useAppState } from "../main";
import { RunMode } from "../main/state";

const sidebar = css({
  height: "100%",
  paddingRight: "1rem"
  // margin: "0.5rem"
});

const LeftSidebar: React.FunctionComponent = () => {
  const { runMode } = useAppState();
  const { nav, signOut } = useActions();
  const isSuperAdmin = runMode === RunMode.superadmin;

  const SuperAdminMenu = () => (
    <div>
      <SlMenu className={menu()}>
        <SlMenuItem
          onClick={() => {
            nav({ route: "/promos/create" });
          }}
        >
          Create Promo
        </SlMenuItem>
        <SlDivider />
        <SlMenuItem
          onClick={() => {
            nav({ route: "/promos/list" });
          }}
        >
          Promos List
        </SlMenuItem>
        <SlDivider />
        <SlMenuItem
          onClick={() => {
            nav({ route: "/redeem/history" });
          }}
        >
          Redeem History
        </SlMenuItem>
        <SlDivider />
        <SlMenuItem
          onClick={() => {
            signOut();
          }}
        >
          Sign out
        </SlMenuItem>
      </SlMenu>
    </div>
  );

  return (
    <aside className={sidebar()}>{isSuperAdmin && <SuperAdminMenu />}</aside>
  );
};

export default LeftSidebar;
